import http from "./http";

export const sliderApi = {
  getAll: () => http.get("/api/sliders"),
  getById: (id) => http.get(`/api/sliders/${id}`),

  // şəkil endpoint-i
  getImageUrl: (id) =>
    `${process.env.REACT_APP_API_BASE}/api/sliders/${id}/image`,

  create: ({
    titleAz,
    titleEn,
    titleRu,
    descAz,
    descEn,
    descRu,
    imageFile,
  }) => {
    const fd = new FormData();

    // ✅ backend-in gözlədiyi adlar (dəqiq belə)
    fd.append("titleAz", titleAz ?? "");
    fd.append("titleEn", titleEn ?? "");
    fd.append("titleRu", titleRu ?? "");

    fd.append("descAz", descAz ?? "");
    fd.append("descEn", descEn ?? "");
    fd.append("descRu", descRu ?? "");

    if (imageFile) fd.append("imageFile", imageFile);

    return http.post("/api/sliders", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  update: (
    id,
    {
      titleAz,
      titleEn,
      titleRu,
      descAz,
      descEn,
      descRu,
      imageFile,
    }
  ) => {
    const fd = new FormData();

    // ✅ update-də istəsən boş göndərə bilərsən (backend necə yazılıbsa)
    if (titleAz !== undefined) fd.append("titleAz", titleAz ?? "");
    if (titleEn !== undefined) fd.append("titleEn", titleEn ?? "");
    if (titleRu !== undefined) fd.append("titleRu", titleRu ?? "");

    if (descAz !== undefined) fd.append("descAz", descAz ?? "");
    if (descEn !== undefined) fd.append("descEn", descEn ?? "");
    if (descRu !== undefined) fd.append("descRu", descRu ?? "");

    if (imageFile) fd.append("imageFile", imageFile);

    return http.put(`/api/sliders/${id}`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  remove: (id) => http.delete(`/api/sliders/${id}`),
};
